// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__VQLez","active":"Tabs_active__f34KE","tab_content":"Tabs_tab_content__XKK8j"};